enum TaxJarExemptionTypeEnum {
    WHOLESALE = "wholesale",
    GOVERNMENT = "government",
    MARKETPLACE = "marketplace",
    OTHER = "other",
    NON_EXEMPT = "non_exempt",
}

export default TaxJarExemptionTypeEnum;
